











































export default {
  name: "WachtwoordInput",
  data() {
    return {
      passwordHidden: true
    };
  },
  props: {
    value: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    passwordValidations() {
      return [
        {
          text: this.$t("WachtwoordInput.validation_length"),
          pattern: ".{8,}"
        }
      ];
    }
  },
  methods: {
    patternCheck(pattern) {
      return new RegExp(pattern).test(this.value);
    },

    invertPasswordHidden() {
      this.passwordHidden = !this.passwordHidden;
    }
  }
};
